import React from "react";
import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import RichText from "@/components/RichText";

const ease = [0.16, 1, 0.3, 1];

const DEFAULT_LINES = [
  "I have always been captivated by the intricacies of suspense and the power of mystery in storytelling.",
  "My approach to crafting compelling and unforgettable thrillers is rooted in passion — intense, thought-provoking, immersive experiences that leave a lasting impact on the audience.",
  "I crave for characters that force me to stretch my limits beyond my own imagination — good or evil.",
  "I love the delicacy of human nature and the subtle intricacies that shape a person's identity and originality.",
];

export default function Approach() {
  const { content } = useContent() || {};
  const ap = content?.approach || {};
  const lines = ap.lines && ap.lines.length ? ap.lines : DEFAULT_LINES;
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative bg-[#0a0a0a] border-y border-white/5 py-24 md:py-40"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="overline mb-12">
          <span className="accent-bar" />
          {ap.kicker || "02 — The Approach"}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-3">
            <p className="overline mb-4">Manifesto</p>
            <p className="font-display italic text-3xl md:text-4xl text-[#c01515] leading-tight">
              {ap.manifesto_quote || "\"Push the boundaries of the thriller genre.\""}
            </p>
          </div>
          <div className="md:col-span-8 md:col-start-5 space-y-10">
            {lines.map((l, idx) => (
              <motion.p
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 1, ease, delay: idx * 0.1 }}
                className="font-display text-2xl md:text-3xl leading-snug text-[#f5f5f5]"
              >
                <span className="font-mono text-xs text-[#990F0F] mr-3 align-top">
                  0{idx + 1}.
                </span>
                <RichText value={l} />
              </motion.p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
